import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.css']
})
export class AlterarSenhaComponent implements OnInit {
  alterarFrm: alterarData = {
    loading: false,
    data: {
      atual: '',
      senha: '',
      nova: ''
    }
  }

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
  }

  Alterar() {
    if (this.alterarFrm.data.senha !== this.alterarFrm.data.nova) {
      Swal.fire({
        title: 'Erro',
        text: 'As novas senhas não coincidem.',
        icon: 'error',
        heightAuto: false,
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          confirmButton: 'btn-swal',
        },
      });
      return;
    }

    if (
      this.alterarFrm.data.atual.length > 0 &&
      this.alterarFrm.data.senha.length > 0 &&
      this.alterarFrm.data.senha === this.alterarFrm.data.nova
    ) {
      this.alterarFrm.loading = true;
      this.userService
        .alterarSenha(this.alterarFrm.data)
        .subscribe(
          (res: any) => {
            localStorage.setItem('botway', JSON.stringify({ "token": res.token, "nome": res.nome, "master": res.master, "permissoes": res.permissoes, "escritorio_id": res.escritorio_id, "escritorio": res.escritorio }));
            Swal.fire({
              title: 'Sucesso',
              text: 'Senha Alterada',
              icon: 'success',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal',
              },
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/home']);
              }
            });
          },
          (err: any) => {
            switch (err.status) {
              case 400:
                Swal.fire({
                  title: 'Erro',
                  text: String(err.error.message),
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
              case 401:
                localStorage.removeItem('botway');
                this.router.navigate(['/login']);
                break;
              case 422:
                let txt = '';
                Object.values(err.error.errors).forEach((value: any, index) => {
                  for (let i = 0; i < Array(value).length; i++) {
                    txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                  }
                });
                Swal.fire({
                  title: 'Erro',
                  html: txt,
                  icon: 'error',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                });
                break;
            }
            this.alterarFrm.loading = false
          },
          () => (this.alterarFrm.loading = false)
        );
    }
  }
}

export interface alterarData {
  loading: boolean;
  data: {
    atual: string;
    senha: string;
    nova: string;
  }
}
